export const PAGE_KEYS = {
  HOME: "home",
  LOGIN_MAIN: "login_main",
  REGISTER_MAIN: "register_main",
  WALLET: "wallet",
  DEPOSIT_FIAT: "deposit_fiat",
  DEPOSIT_CRYPTO: "deposit_crypto",
  WITHDRAW_FIAT: "withdraw_fiat",
  WITHDRAW_CRYPTO: "withdraw_crypto",
  KYC_MAIN: "kyc_main",
};

export const ENTRIES = {
  HOME: "home",
  BANNER: "banner",
  LOGIN_PAGE: "login_page",
  DEEPLINK: "deeplink",
  INVITE: "invite",
  WALLET: "wallet",
  MORE: "more",
  ASSET_DETAIL: "asset_detail",
};

export default PAGE_KEYS;
